export const PUBLIC_AUTH_PATHS = ['/login', '/forgot-password', '/reset-password'];

export function isPublicAuthPath(pathname: string = window.location.pathname): boolean {
  return PUBLIC_AUTH_PATHS.includes(pathname);
}

/** Extract tenant subdomain from a lawmabase.com host URL. */
export function extractSubdomainFromUrl(): string | null {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const fullUrl = `${protocol}//${hostname}`;
  const match = fullUrl.match(/^https?:\/\/([^.]+)\.lawmabase\.com$/);
  return match ? match[1] : null;
}
